const Comments = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="27"
			height="33"
			viewBox="0 0 27 33"
			fill="none"
		>
			<mask
				id="mask0_709_8786"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="27"
				height="33"
			>
				<path d="M26.9442 0H0V32.9999H26.9442V0Z" fill="white" />
			</mask>
			<g mask="url(#mask0_709_8786)">
				<path
					d="M5.00635 32.9999C4.81321 33.0001 4.62261 32.9558 4.4493 32.8706C4.27599 32.7853 4.12462 32.6613 4.00688 32.5082C3.88914 32.3551 3.80819 32.177 3.77029 31.9876C3.7324 31.7982 3.73857 31.6026 3.78833 31.416L4.40998 29.0689C3.12834 28.8031 1.98233 28.0918 1.17533 27.0613C0.368344 26.0308 -0.0474221 24.7477 0.00183153 23.4397V5.68581C-0.0667807 4.25302 0.433899 2.85122 1.39469 1.78609C2.35547 0.720973 3.69842 0.0789382 5.13068 0L21.8161 0C23.2484 0.0789382 24.5913 0.720973 25.5521 1.78609C26.5129 2.85122 27.0136 4.25302 26.945 5.68581V23.4397C27.0133 24.8724 26.5126 26.2741 25.5518 27.3391C24.5911 28.4042 23.2483 29.0463 21.8161 29.1255H11.7606L5.66237 32.817C5.46563 32.9367 5.23972 33 5.00939 32.9999M5.13068 2.52703C4.37073 2.61029 3.67338 2.98716 3.18733 3.57725C2.70128 4.16735 2.46499 4.92398 2.52886 5.68581V23.4397C2.46396 24.203 2.70043 24.9613 3.18764 25.5524C3.67486 26.1436 4.37411 26.5205 5.13574 26.6025H6.03738C6.23056 26.6024 6.42118 26.6467 6.59453 26.732C6.76789 26.8172 6.91935 26.9412 7.03723 27.0942C7.15512 27.2472 7.23628 27.4253 7.27445 27.6147C7.31263 27.8041 7.30681 27.9997 7.25743 28.1864L7.02999 29.0416L10.7558 26.7865C10.9529 26.6676 11.1787 26.6047 11.4088 26.6045H21.8202C22.5818 26.5225 23.281 26.1456 23.7683 25.5545C24.2555 24.9633 24.4919 24.205 24.427 23.4417V5.68581C24.4908 4.92256 24.2533 4.16469 23.7653 3.57435C23.2773 2.98401 22.5777 2.60809 21.8161 2.52703H5.13068Z"
					fill="#5D9BFD"
				/>
			</g>
		</svg>
	);
};

export default Comments;
